import React, { useState, useEffect } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { currency } from "utils/currency/currency";
import DocumentUpload from "components/UI/documentUpload/DocumentUpload";
import AdvancedInputField from "components/UI/AdvancedInputField/AdvancedInputField";

const CurrencyField = ({
  submittedAnswer,
  isFrom,
  handleQuesAnswer,
  event,
  comment,
  question,
  hasAttachedDocument,
}) => {
  const options = currency.map((c) => c.code);
  const [value, setValue] = useState(null);
  const [commentBox, setCommentBox] = useState("");
  const [attachDocument, setAttachDocument] = useState(null);

  useEffect(() => {
    if (submittedAnswer && submittedAnswer?.length > 0) {
      const ans = submittedAnswer?.[0]?.value;
      setValue(options.includes(ans) ? ans : null);
      setCommentBox(submittedAnswer?.[0]?.comment || "");
      setAttachDocument(submittedAnswer[0]?.supporting_document || null);
    }
  }, []);

  const handleChange = (type, newValue) => {
    if (type === "value") {
      setValue(newValue);
    } else if (type === "comment") {
      setCommentBox(newValue);
    } else if (type === "document") setAttachDocument(newValue);

    if (isFrom === "taskSection") {
      handleQuesAnswer({
        obj: {
          value: type === "value" ? newValue : value,
          comment: type === "comment" ? newValue : commentBox,
          weightage: 1,
          supporting_document:
            type === "document" && newValue === null
              ? newValue
              : attachDocument,
          document: type === "document" ? newValue : attachDocument,
          documentMetaData:
            type === "document"
              ? {
                  ques_id: question?._id,
                  name: newValue?.name,
                  is_supporting_document: true,
                  type: newValue?.type,
                }
              : null,
        },
        realQuestion: question,
      });
    }
  };

  return (
    <Box
      mt={2}
      sx={{
        pointerEvents: isFrom === "publishedSurvey" ? "none" : "auto",
      }}
    >
      <Autocomplete
        size="small"
        value={value}
        options={options}
        autoHighlight
        disableClearable={false}
        isOptionEqualToValue={(option, val) => option === val}
        getOptionLabel={(option) => option || ""}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Currency"
            variant="outlined"
            inputProps={{
              ...params.inputProps,
              autoComplete: "off", // prevent autofill bug
            }}
          />
        )}
        onChange={(e, newValue) => handleChange("value", newValue)}
      />

      {comment && (
        <Box mt={2}>
          <AdvancedInputField
            data={commentBox}
            placeholder="Contributor’s comment"
            name="comment"
            handleChange={({ name, value }) => handleChange(name, value)}
          />
        </Box>
      )}

      {hasAttachedDocument && (
        <Box style={{ pointerEvents: event, marginTop: "10px" }}>
          <DocumentUpload
            value={attachDocument}
            isFrom="surveyTask"
            handleChange={handleChange}
            question={"document"}
          />
        </Box>
      )}
    </Box>
  );
};

export default CurrencyField;
